import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { ComplaintService } from "@/services/ComplaintService"

export const getOpenComplaints = (accountNumber: string) => {
  const queries = new QueryAggregator()

  const complaintsQuery = ComplaintService.getForAccount(accountNumber)

  queries.add(complaintsQuery)

  const openComplaintTickets = complaintsQuery.data.filter(
    (complaint) => !complaint.isClosed,
  )
  return queries.setData(openComplaintTickets).getAggregate()
}
